"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const redux_1 = require("redux");
const testDevices = (state = [], action) => {
    if (action.type === 'FETCH_TEST_DEVICES_SUCCESS') {
        return action.testDevices;
    }
    if (action.type === 'DELETE_TEST_DEVICES_SUCCESS') {
        return handleDeleteTestDevicesSucces(state, action);
    }
    return state;
};
const handleDeleteTestDevicesSucces = (state, action) => {
    const deletedIds = new Set(action.deviceIdentifiers);
    return state.filter((d) => !deletedIds.has(d.deviceIdentifier));
};
const selectedTestDevices = (state = [], action) => {
    if (action.type === 'UPDATE_SELECTED_TEST_DEVICES') {
        return action.deviceIds;
    }
    if (action.type === 'DELETE_TEST_DEVICES_SUCCESS') {
        return handleDeleteTestDevicesSuccessForSelectedDevices(state, action);
    }
    return state;
};
const handleDeleteTestDevicesSuccessForSelectedDevices = (state, action) => {
    const deletedIds = new Set(action.deviceIdentifiers);
    return state.filter((d) => !deletedIds.has(d));
};
exports.default = redux_1.combineReducers({
    testDevices,
    selectedTestDevices,
});
exports.getSelectedTestDevices = (state) => state.selectedTestDevices;
exports.getTestDevices = (state) => state.testDevices;
